import { http } from '../utils/http'

const searchAction = (params,page,size) => {
  const url = `/rest/v1/webEdi/search?page=${page}&size=${size}`
  return http.post(url, params)
};
const resendAction = (params) => {
  const url = `/rest/v1/webEdi/resend`
  return http.post(url, params)
};
export default {
  searchAction,
  resendAction,
}
